(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-tmall-payment-choice]');
    const cart = document.querySelector('form.form-cart');
    if (!dialog || !cart || dialog.dataset.ready === 'true') return;

    dialog.dataset.ready = 'true';
    let bypassOnlinePrompt = false;
    let onlineButton = null;
    let activeHost = null;

    const findOnlineButton = (event) => {
      const path = event.composedPath();
      const host = path.find((element) => element instanceof HTMLElement && element.tagName === 'SCALA-CART-BUTTON');
      if (!host || !host.nextElementSibling?.matches('[data-tmall-payment-app-anchor]')) return null;
      activeHost = host;
      return host.shadowRoot?.querySelector('#scala-button') || null;
    };

    const openDialog = (event) => {
      if (bypassOnlinePrompt) return;
      const button = findOnlineButton(event);
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      onlineButton = button;
      if (!dialog.open) dialog.showModal();
      requestAnimationFrame(() => dialog.querySelector('[data-tmall-payment-online]')?.focus());
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    document.addEventListener('click', openDialog, true);
    dialog.querySelector('[data-tmall-payment-close]')?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => activeHost?.focus());

    dialog.querySelector('[data-tmall-payment-online]')?.addEventListener('click', () => {
      const button = onlineButton;
      closeDialog();
      if (!button) return;
      bypassOnlinePrompt = true;
      button.click();
      setTimeout(() => {
        bypassOnlinePrompt = false;
      }, 0);
    });

    dialog.querySelector('[data-tmall-payment-cod]')?.addEventListener('click', () => {
      const submitter = activeHost?.parentElement?.querySelector('.tmall-native-checkout');
      closeDialog();
      if (submitter) cart.requestSubmit(submitter);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
